<template>
    <v-select 
       :value="selected_hoct" 
       v-bind:items="hocts"
       item-value="code" 
       item-text="description" 
       :label="label"
       :clearable="isClearable"
       :multiple="isMultiple"
       @change="updateData">
        <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index >= 0 && index < visibleChips">
                <span>{{ item.name }}</span>
            </v-chip>
            <span v-if="index === visibleChips" class="grey--text text-caption">(+{{ selected_hoct.length - visibleChips }})</span>
        </template>                                                            
    </v-select>
</template>

<script>
export default {
    props: {
        huov_encrid: {
            type: String,
            default: '',
        },
        selected_hoct: {
            type: Array,
            default: function() { return []; },
        },
        label: {
            type: String,
            default: 'Contacts'
        },   
        field: {
            default: 'huov_sel_hoct',
            required: true,
        },
        isClearable:{
            type: Boolean,
            default: false
        },
        isMultiple:{
            type: Boolean,
            default: true
        },  
        visibleChips:{
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            hocts: [],
        }
    },
    created() {
        this.getHoctRecords();
    },
    methods: {
        getHoctRecords() {
            // console.log('parameter',this.huov_encrid);
            this.$axios
                .post("ares/json/ares/huov/getHoct.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHoct"
                    },
                    getHoct: {
                        huov_encrid: this.huov_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error.message);
                    } else {
                        //console.log(res.data);
                        this.hocts = res.data.getHoct;
                    }
                })
        },
        updateData(v){
            this.$emit('updateData', { "field": this.field, "value": v === null ? '' : v })
        }
    }
}
</script>

<style scoped>

</style>